import React, { useState, useEffect } from 'react';
import Breadcumb from '../../Layouts/Breadcumb'
import { Container, Grid, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import Slider from "react-slick";
import { Link, useParams } from 'react-router-dom'
import Review from './Review';
import axios from 'axios';
import { Constants } from '../../endPoints';
import { jwtDecode } from 'jwt-decode';
import Swal from "sweetalert2";


export default function Productdetails() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [sellerInfo, setSellerInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [productImages, setProductImages] = useState([]);
  const [accessToken, setAccessToken] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [showChatBox, setShowChatBox] = useState(false);
  const [chatMessage, setChatMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);



  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    if (token) {
      const decoded = jwtDecode(token);
      setCurrentUserId(decoded.id);
      setAccessToken(token);
      setIsLoggedIn(true);
      fetchUserWishlist(token);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const fetchUserWishlist = async (token) => {
    const decodedToken = jwtDecode(token);
    const idUser = decodedToken.id;

    try {
      const response = await axios.get(`${Constants.getUserWishlist}/${idUser}`);
      console.log('API Response:', response.data);

      if (response.data.status === 1) {
        const wishlistProductIds = response.data.list.map((item) => item.idProduct);
        setWishlist(wishlistProductIds);
      }
    } catch (error) {
      console.error('Error fetching user wishlist:', error);
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${Constants.getProductById}/${id}`);
        if (response.data.success === 1) {
          setProduct(response.data.data); // Set product data
          fetchImagesForProducts(response.data.data); // Fetch images for this product
        } else {
          console.log('Product fetch failed:', response.data);
        }
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    };

    fetchProduct();
  }, [id]); // Fetch product when the `id` changes

  useEffect(() => {
    if (product && product.idUser) {
      const fetchSellerInfo = async () => {
        try {
          const response = await axios.get(`${Constants.userInfoById}/${product.idUser}`);
          console.log('Seller info fetch response:', response); // Log the response
          if (response.data.status === 1) {
            setSellerInfo(response.data.data); // Set seller info
          } else {
            console.log('Seller info fetch failed:', response.data);
          }
        } catch (error) {
          console.error('Error fetching seller info:', error);
        }
      };

      fetchSellerInfo();
    }
  }, [product]); // Runs whenever the product data change


  useEffect(() => {
    if (product && product.id) {
      fetchImagesForProducts(product);  // Fetch images only if product is valid
    }
  }, [product]); // Ensure this runs when the product changes

  const fetchImagesForProducts = async (product) => {
    try {
      const response = await axios.get(`${Constants.getProductImagesById}/${product.id}`);
      if (response.data.status === 1) {
        const fetchedImages = Array.isArray(response.data.data)
          ? response.data.data.map(item => `${Constants.imageBaseURL}/${item.image}`).filter((value, index, self) => self.indexOf(value) === index) // Prevent duplicates
          : [];
        setProductImages(fetchedImages); // Store images in state
      } else {
        console.log('Product images fetch failed:', response.data);
      }
    } catch (error) {
      console.error('Error fetching product images:', error);
    }
  };

  const settings = {
    customPaging: function (i) {
      return (
        <a>
          <img src={productImages[i]} alt={`Thumbnail ${i}`} className="h-16 w-16 object-cover" />
        </a>
      );
    },
    dots: true,
    infinite: false,  // Disable infinite looping to prevent clones
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: productImages.length > 1,
    draggable: productImages.length > 1,
    swipeable: productImages.length > 1,
  };
  // const images = [
  //     'assets/images/bangels-02.png', 
  //     'assets/images/bracelate-2.png',
  //     'assets/images/nackles.png',
  //     'assets/images/earing-2.png',
  // ];

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={`full-${i}`} className="fa-solid fa-star text-orange-400 mr-1"></i>);
    }

    if (halfStar) {
      stars.push(<i key="half" className="fa-regular fa-star-half-stroke text-orange-400 mr-1"></i>);
    }

    while (stars.length < 5) {
      stars.push(<i key={`empty-${stars.length}`} className="fa-regular fa-star text-orange-400 mr-1"></i>);
    }

    return stars;
  };


  useEffect(() => {
    // If there's a feedback message, set a timeout to hide it after 10 seconds
    if (feedbackMessage) {
      const timer = setTimeout(() => {
        setFeedbackMessage('');
        setFeedbackType('');
      }, 5000); // 10 seconds

      // Clear the timer if feedbackMessage changes before the timeout
      return () => clearTimeout(timer);
    }
  }, [feedbackMessage]);

  const handleWishlistClick = async (productId) => {
    if (!isLoggedIn) {
      setFeedbackMessage('Please log in to add products to your wishlist.');
      setFeedbackType('error');
      return;
    }

    // Extract user id from the token
    const decodedToken = jwtDecode(accessToken);
    const idUser = decodedToken.id;

    try {
      const response = await axios.post(`${Constants.addToWishlist}`, {
        idUser,
        idProduct: productId,
      });
      if (response.data.status === 1) {
        // Add to the wishlist array
        setWishlist((prevWishlist) => [...prevWishlist, productId]);
        setFeedbackMessage('Product added to wishlist!');
        setFeedbackType('success');
      } else {
        setFeedbackMessage(response.data.message || 'Something went wrong!');
        setFeedbackType('error');
      }
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      setFeedbackMessage('Error adding to wishlist.');
      setFeedbackType('error');
    }
  };

  const isProductInWishlist = (productId) => {
    return wishlist.includes(productId); // Check if the productId exists in the wishlist
  };

  const fetchChatHistory = async () => {
    if (!accessToken || !product?.id) return;

    const decodedToken = jwtDecode(accessToken);
    const loggedInUserId = decodedToken.id;

    const sellerId = product.idUser; // seller ka id hai
    const buyerId = loggedInUserId;  // abhi login user buyer hai

    try {
      const response = await axios.post(`${Constants.getChatBetweenUsers}`, {
        sender_id: buyerId,
        receiver_id: sellerId,
        product_id: product.id
      });

      if (response.data.status === 1) {
        const messages = response.data.data.map(msg => ({
          text: msg.chat_msg,
          time: new Date(msg.created_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + ", " +
            new Date(msg.created_time).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
          sender: msg.sender_id == loggedInUserId ? 'me' : 'other',
          image_url: msg.image_url || null
        }));

        setChatHistory(messages);
      }
    } catch (error) {
      console.error("Error fetching chat:", error);
    }
  };


  useEffect(() => {
    let interval;

    if (showChatBox) {
      fetchChatHistory(); // initial load
      interval = setInterval(fetchChatHistory, 5000); // refresh every 5 seconds
    }

    return () => clearInterval(interval);
  }, [showChatBox, accessToken, product]);

  const handleSelectImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      file.preview = URL.createObjectURL(file); // Local preview URL
      setSelectedImage(file);
    }
  };



  const handleSendMessage = async () => {
    if (!chatMessage.trim() && !selectedImage) {
      Swal.fire({
        icon: 'warning',
        title: 'Empty Message!',
        text: 'Please type a message or select an image.',
        confirmButtonColor: '#B3902D'
      });
      return;
    }

    try {
      const decodedToken = jwtDecode(accessToken);
      const sender_id = decodedToken.id;
      const receiver_id = product?.idUser;

      if (sender_id === receiver_id) {
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: 'You cannot send a message to yourself!',
          confirmButtonColor: '#B3902D'
        });
        return;
      }

      const formData = new FormData();
      formData.append('sender_id', sender_id);
      formData.append('receiver_id', receiver_id);
      formData.append('product_id', product.id);
      formData.append('msg', chatMessage);
      if (selectedImage) {
        formData.append('image', selectedImage);
      }

      // ✅ Local message push karo pehle (optimistic update)
      const tempMessage = {
        text: chatMessage,
        sender: 'me',
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) + ", " +
          new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }),
        image_url: selectedImage ? URL.createObjectURL(selectedImage) : null // Local preview
      };
      setChatHistory(prev => [...prev, tempMessage]);

      // ✅ Scroll to bottom
      setTimeout(() => {
        const chatBox = document.querySelector(".p-3.h-60.overflow-y-auto");
        if (chatBox) {
          chatBox.scrollTop = chatBox.scrollHeight;
        }
      }, 100);

      // ✅ Ab actual server call
      const response = await axios.post(`${Constants.createChatMessage}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success === 1) {
        setChatMessage('');
        setSelectedImage(null);

        // ✅ Optional: Refresh latest chat history (optional but good)
        fetchChatHistory();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: 'Failed to send message.',
          confirmButtonColor: '#B3902D'
        });
      }

    } catch (error) {
      console.error('Error sending message:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error sending message!',
        confirmButtonColor: '#B3902D'
      });
    }
  };



  useEffect(() => {
    const chatBox = document.querySelector(".p-3.h-60.overflow-y-auto");
    if (chatBox) {
      chatBox.scrollTop = chatBox.scrollHeight;
    }
  }, [chatHistory]);


  return (
    <>
      <Breadcumb pagetitle="Shop" />
      <section className='py-10'>
        <div className='container mx-auto px-4'>
          <Container>
            {feedbackMessage && (
              <div
                className={`mt-4 p-4 text-center rounded-md ${feedbackType === 'success'
                  ? 'bg-green-100 text-green-700'
                  : 'bg-red-100 text-red-700'
                  }`}
              >
                {feedbackMessage}
              </div>
            )}


            {isLoading ? (
              <p>Loading...</p>
            ) : (
              product && (
                <Grid container spacing={4}>
                  <Grid item lg={6} md={5} sm={12} xs={12}>
                    <div className="product-slider">
                      {productImages.length > 0 ? (  // Only render the slider if there are images
                        <Slider {...settings}>
                          {productImages.map((image, index) => (
                            <div key={index}>
                              <img src={image} alt={`Product ${index}`} className="w-full aspect-square object-contain" />
                            </div>
                          ))}
                        </Slider>
                      ) : (
                        <img
                          src={`${Constants.imageBaseURL}product_default.png`}
                          alt="Default Product"
                          className="w-full aspect-square object-contain"
                        />
                      )}
                    </div>
                  </Grid>
                  <Grid item lg={6} md={7} sm={12} xs={12}>
                    <div className='mb-5 pb-5 border-b border-gray-200'>
                      <div className='flex gap-3 justify-between'>
                        <span className='inline-block px-3 py-1 bg-[#A27800] text-white text-sm rounded mb-3'><Link to=""><i class="fa-sharp fa-regular fa-location-dot mr-2"></i> {product.countryName}, {product.stateName}</Link></span>
                        {/* <button class="text-lg text-gray-200 hover:text-[#B3902D] w-10 h-10 rounded-full border border-gray-300"><i class="fa-solid fa-heart"></i> </button> */}
                        <button
                          onClick={() => handleWishlistClick(product.id)}
                          className={`text-lg text-gray-200 hover:text-[#B3902D] w-10 h-10 rounded-full border border-gray-300 transition-all ${isProductInWishlist(product.id) ? 'text text-color-white bg-[#A27800]' : ''}`}
                        >
                          <i className="fa-regular fa-heart"></i>
                        </button>

                      </div>

                      <h2 className='md:text-4xl text-2xl headningfont mb-2 font-semibold'><Link to="">{product.selectionName} {product.categoryName}</Link></h2>
                      <h3 className='mb-3 text-gray-600'><Link to="">Category: {product.categoryName}</Link></h3>
                      <div className='mb-3 flex items-center  tracking-widest'>
                        {renderStars(product.rating || 0)}
                        <span className="text-gray-600 text-sm">
                          {product.rating?.toFixed(1) || "0.0"}/5 • {product.totalReviews} Review{product.totalReviews > 1 ? 's' : ''}
                        </span>
                      </div>

                      <h4 class="md:text-2xl text-sm mb-2 flex gap-3">
                        {/* <span class="text-gray-400 line-through">$100</span> */}
                        <span class="text-[#B3902D] font-semibold">${product.price}</span>
                      </h4>

                    </div>
                    <p className='text-gray-600 mb-8' dangerouslySetInnerHTML={{ __html: product.description }} />


                    <div>
                      <h2 className='md:text-3xl text-2xl text-[#B3902D] headningfont mb-4 font-semibold'><Link to="">Seller Information</Link></h2>
                      <TableContainer>
                        <Table className='border' >
                          <TableBody>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-user mr-2"></i> Name</span></TableCell>
                              <TableCell>{sellerInfo ? `${sellerInfo.firstname} ${sellerInfo.lastname}` : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-envelope mr-2"></i> Email</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.email : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-phone mr-2"></i> Phone</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.phone : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-globe mr-2"></i> Country</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.country : 'Loading...'}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell><span className='font-semibold'><i class="fa-regular fa-location-dot mr-2"></i> City</span></TableCell>
                              <TableCell>{sellerInfo ? sellerInfo.city : 'Loading...'}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>

                    </div>
                    <div className="mt-5 text-center">
                      <button
                        onClick={() => {
                          if (!isLoggedIn) {
                            Swal.fire({
                              icon: 'warning',
                              title: 'Login Required',
                              text: 'Please login to chat with the seller.',
                              confirmButtonColor: '#B3902D'
                            });
                            return;
                          }
                          if (currentUserId === sellerInfo?.id) {
                            Swal.fire({
                              icon: 'error',
                              title: 'Oops!',
                              text: 'You cannot chat with yourself.',
                              confirmButtonColor: '#B3902D'
                            });
                            return;
                          }
                          setShowChatBox(true);
                        }}
                        className="bg-[#B3902D] text-white py-2 px-5 rounded-full hover:bg-[#a27800] transition"
                      >
                        Chat With Seller
                      </button>
                    </div>
                    {showChatBox && (
                      <div className="fixed bottom-5 right-10 w-72 shadow-lg rounded border bg-white z-50">
                        <div className="bg-[#B3902D] text-white px-4 py-2 rounded-t flex justify-between items-center">
                          <span className="font-semibold">{sellerInfo?.firstname || 'Seller'}</span>
                          <button onClick={() => setShowChatBox(false)} className="text-white font-bold text-xl">&times;</button>
                        </div>
                        <div className="p-3 h-60 overflow-y-auto">
                          {chatHistory.map((msg, index) => (
                            <div key={index} className={`mb-3 flex ${msg.sender === 'me' ? 'justify-end' : 'justify-start'}`}>
                              <div className={`max-w-[75%] px-3 py-2 rounded-lg text-sm ${msg.sender === 'me' ? 'bg-blue-100' : 'bg-orange-100'}`}>
                                {msg.image_url && (
                                  <img
                                    src={msg.image_url}
                                    alt="Chat Image"
                                    className="w-32 h-auto rounded mb-2"
                                  />
                                )}
                                {msg.text && (
                                  <div>{msg.text}</div>
                                )}
                                <div className="text-[10px] text-gray-500 mt-1 text-right">{msg.time}</div>
                              </div>
                            </div>
                          ))}

                          {selectedImage && selectedImage.preview && (
                            <div className="mb-3 flex justify-end">
                              <div className="max-w-[75%] px-3 py-2 rounded-lg text-sm bg-blue-100">
                                <img
                                  src={selectedImage.preview}
                                  alt="Selected Preview"
                                  className="w-32 h-auto rounded mb-2"
                                />
                              </div>
                            </div>
                          )}

                        </div>

                        <div className="flex border-t">
                          <input
                            type="file"
                            onChange={handleSelectImage}
                            className="hidden"
                            id="imageUpload"
                          />
                          <label htmlFor="imageUpload" className="bg-[#B3902D] text-white px-3 flex items-center justify-center cursor-pointer">
                            <i className="fa fa-paperclip text-sm"></i>
                          </label>
                          <textarea onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                              e.preventDefault();
                              handleSendMessage();
                            }
                          }}
                            rows="1"
                            className="flex-grow p-2 border-0 focus:outline-none text-sm"
                            placeholder="Type your message here"
                            value={chatMessage}
                            onChange={(e) => setChatMessage(e.target.value)}
                          />
                          <button
                            onClick={() => handleSendMessage()}
                            className="bg-black text-white px-3 flex items-center justify-center"
                          >
                            <i className="fa fa-paper-plane text-sm"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </Grid>
                </Grid>
              )
            )}
            <div className='mt-10'>
              <Review />
            </div>
          </Container>
        </div>
      </section>
    </>
  )
}
